import React from 'react';

function SiteFooter({ isDark }) {
  return (
    <footer
      className={`mt-8 rounded-2xl border px-5 py-6 md:px-6 ${
        isDark ? 'border-slate-700 bg-slate-900/80' : 'border-white/80 bg-white/85'
      }`}
    >
      <div className="grid gap-5 md:grid-cols-4">
        <section>
          <h3 className="text-sm font-black uppercase tracking-[0.18em] text-cyan-500">Postcard SaaS</h3>
          <p className={`mt-2 text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
            AI-powered direct mail automation for modern teams.
          </p>
        </section>

        <section>
          <h4 className="text-sm font-bold">Solutions</h4>
          <ul className={`mt-2 space-y-1 text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
            <li>Direct Mail API</li>
            <li>Storefront Solution</li>
            <li>CRM Integration</li>
          </ul>
        </section>

        <section>
          <h4 className="text-sm font-bold">Company</h4>
          <ul className={`mt-2 space-y-1 text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
            <li>Pricing</li>
            <li>About</li>
            <li>Contact</li>
          </ul>
        </section>

        <section>
          <h4 className="text-sm font-bold">Support</h4>
          <ul className={`mt-2 space-y-1 text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
            <li>support@postcardsaas.com</li>
            <li>1-800-690-0945</li>
            <li>Mon-Fri, 9AM-6PM EST</li>
          </ul>
        </section>
      </div>

      <div
        className={`mt-5 border-t pt-4 text-center text-xs ${
          isDark ? 'border-slate-700 text-slate-400' : 'border-slate-200 text-slate-500'
        }`}
      >
        Copyright {new Date().getFullYear()} Postcard SaaS. All rights reserved.
      </div>
    </footer>
  );
}

export default SiteFooter;
